module.exports = "pegasus/assets/tech/email1-gallery-img5.png";